import React from 'react'

class List extends React.Component {

    renderArray(items, renderItem){
        return items.map(renderItem);
    }

    renderObject(items, renderItem) {
        return Object.keys(items).map(key => {
            let item = items[key];
            return renderItem(item, key);
        });
    }

    render () {
        let renderItem = this.props.children || (item => {
            return (
                <div className="list-item">
                    { JSON.stringify(item) }
                </div>
            );
        });

        let children = null;

        if (Array.isArray(this.props.items)) {
            children = this.renderArray(this.props.items, renderItem);
        } else if (typeof this.props.items === 'object' && !Array.isArray(this.props.items)) {
            children = this.renderObject(this.props.items, renderItem);
        }

        return (
            <div className={['component-list', this.props.className].join(' ')}>
                {children}
            </div>
        )
    }
}

export default List;



// WEBPACK FOOTER //
// ./web-app/components/list.jsx